import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  connect() {
    this.element.setAttribute("novalidate", true)
  }

  validate(event) {
    this.clearErrors()

    // Find all required fields (including select with data-required inside data attribute)
    const requiredFields = this.element.querySelectorAll("[required], [data-required='true']")
    let isValid = true

    requiredFields.forEach(field => {
      if (!this.isFieldValid(field)) {
        isValid = false
        this.showError(field)
      }
    })

    if (!isValid) {
      event.preventDefault()
      // Scroll to first error
      const firstError = this.element.querySelector(".border-red-500, .ts-wrapper.border-red-500")
      if (firstError) {
        firstError.scrollIntoView({ behavior: "smooth", block: "center" })
        // Focus the actual input if possible
        const input = firstError.querySelector("input") || firstError
        if (input.focus) input.focus()
      }
    }
  }

  isFieldValid(field) {
    // For select fields (including tom-select)
    if (field.tagName === "SELECT") {
      return field.value && field.value !== ""
    }

    // Standard validation
    if (field.type === "checkbox") {
      return field.checked
    }

    return field.value && field.value.trim() !== ""
  }

  showError(field) {
    // Handle tom-select wrapped fields (select becomes hidden, wrapper is visible)
    if (field.tagName === "SELECT") {
      const tomSelectWrapper = field.nextElementSibling
      if (tomSelectWrapper && tomSelectWrapper.classList.contains("ts-wrapper")) {
        tomSelectWrapper.classList.add("border-red-500", "border-2", "rounded-lg")
        return
      }
    }

    field.classList.remove("border-gray-300", "dark:border-gray-700")
    field.classList.add("border-red-500", "focus:border-red-500", "focus:ring-red-500")
  }

  clearErrors() {
    // Clear standard fields
    this.element.querySelectorAll(".border-red-500:not(.ts-wrapper)").forEach(field => {
      field.classList.remove("border-red-500", "focus:border-red-500", "focus:ring-red-500")
      field.classList.add("border-gray-300", "dark:border-gray-700")
    })

    // Clear tom-select wrappers
    this.element.querySelectorAll(".ts-wrapper.border-red-500").forEach(wrapper => {
      wrapper.classList.remove("border-red-500", "border-2", "rounded-lg")
    })
  }

  clearFieldError(event) {
    const field = event.target

    // For select with tom-select
    if (field.tagName === "SELECT") {
      const tomSelectWrapper = field.nextElementSibling
      if (tomSelectWrapper && tomSelectWrapper.classList.contains("ts-wrapper")) {
        tomSelectWrapper.classList.remove("border-red-500", "border-2", "rounded-lg")
        return
      }
    }

    field.classList.remove("border-red-500", "focus:border-red-500", "focus:ring-red-500")
    field.classList.add("border-gray-300", "dark:border-gray-700")
  }
}
